<template>
  <div>
    <div v-if="loading">Cargando reporte...</div>
    <v-row v-else no-gutters>
      <!-- 
        titulo: 'Datos Generales',  
        datos: this.datosGenerales -->
      <v-col cols="12" sm="12" md="12" lg="6">
        <v-card flat>
          <v-card-text>
            <h2>Datos Generales</h2>
            <v-simple-table dense>
              <tbody>
                <tr v-for="(val, key) in datosGenerales" :key="key">
                  <td>{{ key }}</td>
                  <td>{{ val }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 
        titulo: 'Identificaciones',
        datos: this.identificaciones -->
      <v-col cols="12" sm="12" md="12" lg="6">
        <v-card flat>
          <v-card-text>
            <h2 class="mt-3">Identificaciones</h2>
            <v-data-table :items-per-page="-1" :hide-default-footer="true" :headers="identHeaders"
              :items="identificaciones" dense class="mt-3"></v-data-table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 
        titulo: 'Localización',
        datos: this.localizacionData -->
      <v-col cols="12" sm="12" md="12" lg="6">
        <v-card flat>
          <v-card-text>
            <h2>Localización</h2>
            <v-simple-table dense>
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Teléfono</th>
                  <th>Dirección</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in localizacionData" :key="i">
                  <td>{{ item.tipo }}</td>
                  <td>{{ item.telefono }}</td>
                  <td>{{ item.direccion }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 
        titulo: 'SCORE',
        datos: this.modelos -->
      <v-col cols="12" sm="12" md="12" lg="6">
        <v-card flat>
          <v-card-text>
            <h2 class="mt-3">SCORE</h2>
            <v-data-table :items-per-page="-1" :hide-default-footer="true" :headers="modeloHeaders" :items="modelos"
              dense class="mt-3"></v-data-table>
          </v-card-text>
        </v-card>
      </v-col>


      <!-- 
        titulo: 'Consultas Realizadas',
        datos: this.consultas -->
      <v-col cols="12" sm="12" md="12" lg="6">
        <v-card flat>
          <v-card-text>
            <h2 class="mt-3">Consultas Realizadas</h2>
            <v-data-table :items-per-page="-1" :hide-default-footer="true" :headers="consultaHeaders" :items="consultas"
              dense class="mt-3"></v-data-table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 
        titulo: 'Resumen de Cuenta',
        datos: this.resumenData -->
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-card flat>
          <v-card-text>
            <h2>Resumen de Cuentas</h2>
            <v-data-table :items-per-page="-1" :headers="resumenHeaders" :items="resumenData" dense class="mt-3"
              hide-default-footer></v-data-table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 
        titulo: 'COMPORTAMIENTO DE CREDITOS VIGENTES Y CANCELADOS',
        datos: this.obligacionesData -->
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-card flat>
          <v-card-text>
            <h2>Comportamiento de creditos vigentes y cancelados</h2>
          </v-card-text>
        </v-card>
        
        <v-data-table :headers="obligacionesHeaders" :items="obligacionesData" dense class="mt-3" :items-per-page="-1"
          hide-default-footer hide-default-header :fixed-header="false" style="width: 100%; table-layout: auto;">
          <template v-slot:header="{ props }">
            <tr>
              <th v-for="header in props.headers" :key="header.text" class="text-xs" style="font-size: 8px;">
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-xs" style="font-size: 10px!important;">{{ item.codigo }}</td>
              <td class="text-xs" style="font-size: 10px!important;">{{ item.tipo }}</td>
              <td class="text-xs" style="font-size: 10px!important;">{{ item.sector }}</td>
              <td class="text-xs" style="font-size: 8px!important;">{{ item.entidad }}</td>
              <td class="text-xs" style="font-size: 10px!important;">{{ item.tipoCredito }}</td>
              <td class="text-xs" style="font-size: 10px!important;">{{ item.garantia }}</td>
              <td class="text-xs" style="font-size: 10px!important;">{{ item.numero }}</td>
              <td class="text-xs" style="font-size: 8px!important;">{{ item.fechaApertura }}</td>
              <td class="text-xs" style="font-size: 8px!important;">{{ item.fecVencimiento }}</td>
              <td class="text-xs" style="font-size: 8px!important;">{{ item.fechaActualizacion }}</td>
              <td class="text-xs" style="font-size: 8px!important;">{{ item.periodoPago }}</td>
              <td class="text-xs" style="font-size: 8px!important;">{{ item.calificacion }}</td>
              <td class="text-xs" style="font-size: 8px!important;">{{ item.moneda }}</td>
              <td class="text-xs" style="font-size: 8px!important;">{{ item.estado }}</td>
              <td class="text-xs" style="font-size: 8px!important;">{{ item.status }}</td>
              <td class="text-xs" style="font-size: 10px!important;">{{ item.diasMora }}</td>
              <td class="text-xs" style="font-size: 10px!important;">{{ item.limite }}</td>
              <td class="text-xs" style="font-size: 10px!important;">{{ item.saldoActual }}</td>
              <td class="text-xs" style="font-size: 10px!important;">{{ item.saldoMora ? item.saldoMora : '0.00' }}</td>
              <td class="text-xs" style="font-size: 10px!important;">{{ item.cuota }}</td>
            </tr>
          </template>
          <template v-slot:body.append>
            <tr>
              <td colspan="16" class="text-right font-weight-bold">Totales</td>
              <td class="text-xs" style="font-size: 10px!important;">{{ totalLimite }}</td>
              <td class="text-xs" style="font-size: 10px!important;">{{ totalSaldoActual }}</td>
              <td class="text-xs" style="font-size: 10px!important;">{{ totalSaldoMora }}</td>
              <td class="text-xs" style="font-size: 10px!important;">{{ totalCuota }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-col>

      <!-- 
        titulo: 'Vector Histórico',
        datos: this.vectorData -->
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-card flat>
          <v-card-text>
            <h2 class="mt-3">Vector Histórico</h2>
            <v-simple-table dense :hide-default-footer="true" class="mt-3">
              <thead>
                <tr>
                  <th class="text-xs" style="font-size: 9px!important;">Código</th>
                  <th></th>
                  <th colspan="100%" class="text-center text-xs" style="font-size: 9px!important;">Periodo</th>
                </tr>
              </thead>
              <tbody v-for="(vec, index) in vectorData" :key="index">
                <tr>
                  <td>{{ vec.codigo }}</td>
                  <td>Año</td>
                  <td v-for="(it, i) in vec.items" :key="'anio' + i" class="text-xs" style="font-size: 8px!important;">{{
                    it.anio }}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Mes</td>
                  <td v-for="(it, i) in vec.items" :key="'mes' + i" class="text-xs" style="font-size: 8px!important;">{{
                    it.mes
                    }}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Mora</td>
                  <td v-for="(it, i) in vec.items" :key="'mora' + i" class="text-xs" style="font-size: 8px!important;">{{
                    it.mora }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: ['prop_xml'],
  data() {
    return {
      localizacionData: [],
      resumenData: [],
      resumenHeaders: [
        { text: 'Tipo Obligación', value: 'tipoObligacion' },
        { text: 'Estatus', value: 'estatus' },
        { text: 'Tipo Cuenta', value: 'tipoCuenta' },
        { text: 'Estado', value: 'estado' },
        { text: 'Cantidad', value: 'cantidad' }
      ],
      obligacionesData: [],
      obligacionesHeaders: [
        { text: 'Código', value: 'codigo', width: 15 },
        { text: 'Tipo Obligación', value: 'tipo', width: '15px' },
        { text: 'Sector', value: 'sector' },
        { text: 'Entidad', value: 'entidad' },
        { text: 'Tipo Crédito', value: 'tipoCredito' },
        { text: 'Garantía', value: 'garantia' },
        { text: 'Número Crédito', value: 'numero' },
        { text: 'Fecha Apertura', value: 'fechaApertura' },
        { text: 'Fecha Vencimiento', value: 'fecVencimiento' },
        { text: 'Fecha Actualización', value: 'fechaActualizacion' },
        { text: 'Periodo Pago', value: 'periodoPago' },
        { text: 'Calificación', value: 'calificacion' },
        { text: 'Moneda', value: 'moneda' },
        { text: 'Estado', value: 'estado' },
        { text: 'Status', value: 'status' },
        { text: 'Días Mora', value: 'diasMora' },
        { text: 'Límite Crédito', value: 'limite' },
        { text: 'Saldo Actual', value: 'saldoActual' },
        { text: 'Saldo Mora', value: 'saldoMora' },
        { text: 'Cuota', value: 'cuota' }
      ],
      vectorData: [],
      loading: true,
      datosGenerales: {},
      identificaciones: [],
      consultas: [],
      modelos: [],
      identHeaders: [
        { text: 'Tipo', value: 'tipo' },
        { text: 'Número', value: 'numero' },
        { text: 'Estado', value: 'estado' }
      ],
      consultaHeaders: [
        { text: 'Entidad consultante', value: 'entidadConsultante' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Motivo', value: 'motivo' }
      ],
      modeloHeaders: [
        { text: 'Producto', value: 'producto' },
        { text: 'Resultado', value: 'resultado' }
      ]
    };
  },
  created() {
    this.loadXML();
  },
  methods: {
    parseLocalizacion(xmlDoc) {
      const data = [];
      const dirTelList = xmlDoc.querySelectorAll('localizacion > direccionYTelefono');

      dirTelList.forEach(node => {
        const tipo = node.querySelector('tipo')?.textContent || '';
        const telefono = node.querySelector('telefono')?.textContent || '';

        let direccion = '';
        const direccionNode = node.querySelector('direccion');
        if (direccionNode) {
          direccion = direccionNode.querySelector('desc')?.textContent || '';

          if (tipo.toUpperCase() === 'RESIDENCIAL') {
            // Para RESIDENCIAL agregamos divisiones geográficas
            const div1 = direccionNode.querySelector('divisionGeografica1')?.textContent || '';
            const div2 = direccionNode.querySelector('divisionGeografica2')?.textContent || '';
            direccion = `${direccion} ${div1} ${div2}`.trim();
          }
        }

        data.push({
          tipo,
          telefono,
          direccion
        });
      });

      this.localizacionData = data;
    },
    parseResumenCuentas(xmlDoc) {
      const data = [];

      const vigentes = xmlDoc.querySelectorAll('resumenCuentas > obligacionesVigentes resumenTipoCuenta');
      vigentes.forEach(node => {
        data.push({
          tipoObligacion: 'FINANCIERAS VIGENTES',
          estatus: node.querySelector('estado')?.textContent || '',
          tipoCuenta: node.querySelector('tipoCuenta')?.textContent || '',
          estado: node.querySelector('estado')?.textContent || '',
          cantidad: node.querySelector('cantidad')?.textContent || ''
        });
      });

      const cerradas = xmlDoc.querySelectorAll('resumenCuentas > obligacionesCerradas resumenTipoCuenta');
      cerradas.forEach(node => {
        data.push({
          tipoObligacion: 'OBLIGACIONES CERRADAS',
          estatus: node.querySelector('estado')?.textContent || '',
          tipoCuenta: node.querySelector('tipoCuenta')?.textContent || '',
          estado: node.querySelector('estado')?.textContent || '',
          cantidad: node.querySelector('cantidad')?.textContent || ''
        });
      });

      this.resumenData = data;
    },
    parseObligaciones(xmlDoc) {
      const result = [];
      const obligaciones = xmlDoc.querySelectorAll('comportamientoObligaciones > obligacion');

      obligaciones.forEach(ob => {
        const entidad = ob.querySelector('entidadInformante');
        const tipo = ob.getAttribute('tipoObs') || '';
        const sector = ob.getAttribute('sector') || '';

        // 🔁 obtener TODOS los comportamientos de pago
        const comportamientos = ob.querySelectorAll('comportamientoPago');
        comportamientos.forEach(comp => {
          result.push({
            codigo: ob.querySelector('creditoConsecutivo')?.textContent || '',
            tipo,
            sector,
            entidad: entidad?.textContent || '',
            entidadCodigo: entidad?.getAttribute('codigo') || '',
            tipoCredito: ob.querySelector('tipo')?.textContent || '',
            garantia: ob.querySelector('garantia')?.textContent || '',
            numero: ob.querySelector('numero')?.textContent || '',
            fechaApertura: ob.querySelector('fechaApertura')?.textContent?.split('T')[0] || '',
            fecVencimiento: ob.querySelector('fecVencimiento')?.textContent?.split('T')[0] || '',
            fechaActualizacion: ob.querySelector('fechaActualizacion')?.textContent?.split('T')[0] || '',
            periodoPago: ob.querySelector('periodoPago')?.textContent || '',
            calificacion: comp.querySelector('calificacion')?.textContent || '',
            moneda: comp.querySelector('moneda')?.textContent || '',
            estado: comp.querySelector('estado')?.textContent || '',
            status: comp.querySelector('estado')?.getAttribute('vigente') || '',
            diasMora: comp.querySelector('diasMora')?.textContent || '',
            limite: comp.querySelector('limite')?.textContent || '',
            saldoActual: comp.querySelector('saldoActual')?.textContent || '',
            saldoMora: comp.querySelector('saldoMora')?.textContent || '',
            cuota: comp.querySelector('cuota')?.textContent || ''
          });
        });
      });

      this.obligacionesData = result;
    },
    parseVectorHistorico(xmlDoc) {
      const vectorList = [];
      const obligaciones = xmlDoc.querySelectorAll('comportamientoObligaciones > obligacion');

      obligaciones.forEach(ob => {
        const codigo = ob.querySelector('numero').textContent;

        //const entidad = ob.querySelector('entidadInformante');
        //const codEntidad = entidad?.getAttribute('codigo') || '';

        const comportamientos = ob.querySelectorAll('comportamientoPago');
        comportamientos.forEach(cp => {
          const vector = cp.querySelector('vectorHistorico');
          if (vector) {
            const anio = vector.getAttribute('anio') || '';
            const items = Array.from(vector.querySelectorAll('item')).map(it => ({
              anio: it.getAttribute('anio') || '',
              mes: it.getAttribute('mes') || '',
              mora: it.textContent.trim()
            }));
            vectorList.push({
              codigo: codigo,
              anio,
              items
            });
          }
        });
      });

      this.vectorData = vectorList;
    },
    async loadXML() {
      try {
        const res = await axios.get(
          this.prop_xml,
          { responseType: 'text' }
        );
        this.parseXML(res.data);
      } catch (err) {
        console.error('Error cargando XML', err);
      } finally {
        this.loading = false;
      }
    },
    parseXML(xmlStr) {
      const parser = new DOMParser();
      const xml = parser.parseFromString(xmlStr, 'text/xml');

      // Datos generales
      const dg = xml.querySelector('datosGenerales');
      this.datosGenerales = {
        'Nombre Completo': dg.querySelector('nombreCompleto')?.textContent,
        'Fecha Nacimiento': dg.querySelector('fechaNacimiento')?.textContent,
        'Edad': dg.querySelector('edad')?.textContent,
        'Género': dg.querySelector('genero')?.textContent,
        'Estado Civil': dg.querySelector('estadoCivil')?.textContent,
      };

      // Identificaciones
      this.identificaciones = Array.from(dg.querySelectorAll('identificacionSujeto')).map(id => ({
        tipo: id.querySelector('tipo')?.textContent,
        numero: id.querySelector('numero')?.textContent,
        estado: id.querySelector('estado')?.textContent
      }));

      // Consultas
      this.consultas = Array.from(xml.querySelectorAll('listaConsultas > consulta')).map(c => ({
        entidadConsultante: c.querySelector('entidadConsultante')?.textContent,
        tipo: c.querySelector('tipoConsulta')?.textContent,
        fecha: c.querySelector('fecha')?.textContent,
        motivo: c.querySelector('motivo')?.textContent
      }));

      // Modelos
      this.modelos = Array.from(xml.querySelectorAll('modelosAnalisis > modelo')).map(m => ({
        producto: m.querySelector('producto')?.textContent,
        resultado: m.querySelector('resultado')?.textContent
      }));

      this.parseVectorHistorico(xml);

      this.parseObligaciones(xml);

      this.parseResumenCuentas(xml);

      this.parseLocalizacion(xml);



    }
  },
  computed: {
    totalLimite() {
      return this.obligacionesData.reduce((acc, o) => acc + Number(o.limite || 0), 0).toFixed(2);
    },
    totalSaldoActual() {
      return this.obligacionesData.reduce((acc, o) => acc + Number(o.saldoActual || 0), 0).toFixed(2);
    },
    totalSaldoMora() {
      return this.obligacionesData.reduce((acc, o) => acc + Number(o.saldoMora || 0), 0).toFixed(2);
    },
    totalCuota() {
      return this.obligacionesData.reduce((acc, o) => acc + Number(o.cuota || 0), 0).toFixed(2);
    }
  }
};
</script>
<style scoped>
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table>.v-data-table__wrapper>table>tbody>tr>th,
.v-data-table>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table>.v-data-table__wrapper>table>thead>tr>th,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>td,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>th {
  padding: 0 5px !important;
  transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}
</style>